import React from 'react';

const TestRemediation = ({ remediationSteps }) => {
  return (
    <div className="p-4 border-t border-gray-200">
      <h3 className="text-lg font-medium mb-3">Remediation Steps</h3>
      {Array.isArray(remediationSteps) && remediationSteps.length > 0 ? (
        <ol className="list-decimal pl-5 text-gray-700 space-y-2">
          {remediationSteps.map((step, index) => (
            <li key={index} className="pl-1">{step}</li>
          ))}
        </ol>
      ) : (
        <p className="text-gray-700">No remediation steps available.</p>
      )}
    </div>
  );
};

export default TestRemediation;
